export const profile = {
  name: "Amelia King",
  degree: "Ph.D. Candidate in Computational Biology",
  affiliation: "Sample University",
  email: "amelia.king@example.edu",
  tagline:
    "I study how complex biological systems can be understood through computation, with a focus on clear questions and careful methods.",
  about: `I am a researcher interested in the intersection of computation and the life sciences. My work explores how models can illuminate patterns in noisy biological data, and how careful experimental design can make those models more useful.

Outside of research, I care about clear scientific writing, open methods, and making complex ideas feel approachable. This site collects my CV, publications, and occasional notes.`,
  headshot: "/images/headshot.svg",
};

export const socials = [
  { label: "Email", href: "mailto:amelia.king@example.edu", icon: "mail" },
  { label: "Google Scholar", href: "https://scholar.google.com", icon: "scholar" },
  { label: "ORCID", href: "https://orcid.org", icon: "orcid" },
  { label: "GitHub", href: "https://github.com/AmeliaK27", icon: "github" },
  { label: "LinkedIn", href: "https://linkedin.com", icon: "linkedin" },
  { label: "X", href: "https://x.com", icon: "x" },
];

export const cv = {
  education: [
    {
      period: "2022 — Present",
      title: "Ph.D. in Computational Biology",
      place: "Sample University",
      detail: "Advisor: Prof. Sample Name. Focus on statistical models for biological networks.",
    },
    {
      period: "2018 — 2022",
      title: "B.S. in Biology & Computer Science",
      place: "Sample College",
      detail: "Summa cum laude. Thesis on comparative genomics of model organisms.",
    },
  ],
  experience: [
    {
      period: "2023 — Present",
      title: "Graduate Research Assistant",
      place: "Lab of Computational Biology, Sample University",
      detail: "Developing methods for integrating multi-omic datasets and validating models against experimental assays.",
    },
    {
      period: "Summer 2021",
      title: "Research Intern",
      place: "Sample Institute for Genomics",
      detail: "Built analysis pipelines for high-throughput sequencing data.",
    },
  ],
  awards: [
    { year: "2024", title: "Sample Graduate Fellowship" },
    { year: "2022", title: "Departmental Honors in Biology" },
    { year: "2021", title: "Summer Research Grant" },
  ],
  skills: [
    "Python",
    "R",
    "Statistical modeling",
    "Genomics",
    "Scientific writing",
    "Data visualization",
  ],
};

export const publications = [
  {
    year: 2025,
    title: "Sample Title: Modeling Soft Transitions in Biological Networks",
    authors: "King, A., Sample, B., & Other, C.",
    venue: "Journal of Sample Science",
    links: { pdf: "#", doi: "#" },
  },
  {
    year: 2024,
    title: "A Gentle Framework for Integrating Noisy Multi-Omic Measurements",
    authors: "King, A. & Mentor, D.",
    venue: "Proceedings of Sample Conference",
    links: { pdf: "#", code: "#" },
  },
  {
    year: 2023,
    title: "Notes on Clarity in Computational Biology Writing",
    authors: "King, A.",
    venue: "Preprint / Sample Archive",
    links: { pdf: "#" },
  },
];

export const defaultPosts = [
  {
    id: "welcome",
    title: "Welcome to the blog",
    date: "2025-06-01",
    excerpt: "A short note about what I’ll share here — research ideas, reading lists, and the occasional travelogue.",
    body: `This is a sample post. Replace it with your own writing whenever you like.

I’ll use this space for longer thoughts that don’t fit in a paper abstract: method reflections, conference notes, and gentle progress updates.`,
  },
  {
    id: "reading-list",
    title: "A spring reading list",
    date: "2025-04-12",
    excerpt: "A handful of papers and essays that shaped how I’ve been thinking lately.",
    body: `Sample content only — swap in the books and papers that matter to you.

1. A careful methods paper that slowed me down in a good way.
2. An essay on scientific communication that reminded me clarity is a form of kindness.
3. A preprint that asked a question I wish I’d asked first.`,
  },
];

/** Demo admin password for the local sample admin panel. Change later. */
export const ADMIN_PASSWORD = "daydream";
